import React from 'react';
import $ from 'jquery'
import {
  createFragmentContainer,
  graphql,
} from 'react-relay';
import withStyles from "@material-ui/core/styles/withStyles";
import AccountCircle from '@material-ui/icons/AccountCircle';
import headerStyle from "assets/jss/components/Header";
import {typeFn, maxStrDisplay, recursivePath} from "local-util"
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Hidden from "@material-ui/core/Hidden";
import Button from "assets/material-admin/components/CustomButtons/Button";
import Menu from "@material-ui/icons/Menu";
import IconButton from '@material-ui/core/IconButton';

const Breadcrumbs = withStyles(headerStyle)(
  class Breadcrumbs extends React.Component {
    createLink(item) {
      const t = item.type
      const companyId = this.props.company.id
      if (t == "Company") {
        return `/company/${companyId}`
      }
      else if (t == "Strategy") {
        return `/company/${companyId}/strategy/${item.id}`
      }else if (t == "Coaching Strategy") {
        return `/company/${companyId}/coachingstrategy/${item.id}`
      } else if (t == "Big Goal") {
        return `/company/${companyId}/bigGoal/${item.id}`
      } else if (t == "Step Goal") {
        return `/company/${companyId}/stepGoal/${item.id}`
      } else if (t == "Action Plan") {
        return `/company/${companyId}/actionPlan/${item.id}`
      } else if (t == "Employee") {
        return `/company/${companyId}/employee`
      } else if (t == "Create Invite") {
        return `/company/${companyId}/invite`
      } else if (t == "Create Strategy") {
        return `/company/${companyId}/createStrategy`
      } else if (t == "Timeline") {
        return `/company/${companyId}/timeline/`
      } else if (t == "Archive") {
        return `/company/${companyId}/archive`
      }

      return "/"
    }
    createSingleCrumb({key, link, name}) {
      return (
        <Typography classes={{root: this.props.classes.headerRoot}}
                    key={key} variant="subheading"
                    onClick={() => {
                      this.props.router.push(this.createLink(link))
          }}
          color="inherit">
          {maxStrDisplay(name, 20)}
        </Typography>
      )
    }
    createCrumb(item) {
      const companyId = this.props.company.id
      const classes = this.props.classes
	    const link = this.createLink(item)
      return (
        <Typography classes={{root: classes.headerRoot}}
                    key={item.id} variant="subheading"
                    onClick={() => {
                      this.props.router.push(link)
                    }}
                    color="inherit">
          <a style={{color: "inherit"}} href={`${link}`}>
            {maxStrDisplay(item.name, 20)}
        </a>

        </Typography>
      )
    }
    render() {
      const {classes} = this.props

      const path = this.props.path
      const breadcrumbs = path.map((p)  => {
        return this.createCrumb(p)
      })

      const singleItem = path[path.length -1]

      const single = this.createCrumb(singleItem)
      const singleHidden = (<Hidden key={"breadcrumbsUp"} mdUp>
                            {single}
                            </Hidden>)
      const singleNotHidden = (<Hidden key="breadcrumbsDown" smDown>
                               {breadcrumbs}
                               </Hidden>)
      return [singleHidden, singleNotHidden]
    }
  }
)

const Header = withStyles(headerStyle)(
  class Header extends React.Component {
    planFromProps(company) {
      const params = this.props.params
      const activePropId = params.strategyId || params.bigGoalId || params.stepGoalId || params.actionPlanId

      if (company && company.strategies && activePropId) {
        let pathObjs = {}
        let path = recursivePath(company, [], pathObjs)

        return pathObjs[activePropId]
      } else {
        if (company && company.strategies && company.strategies.length > 0) {
          let pathObjs = {}
          let path = recursivePath(company, [], pathObjs)

          return pathObjs[company.id]
        }

      }
    }
    getHeaderType() {
      const t = this.props.route.headerType
      if (t) {
        return this.props.route.headerType
      } else {
        const t = this.props.routes.find((x) => {
          return x.headerType
        })

        if (t) {
          return t.headerType
        }

      }
    }
    render() {
      const {classes, ...rest} = this.props
      const company = this.props.activeCompany
      const path = this.planFromProps(company)

      const headerType = this.getHeaderType()

      let component

      if (headerType == 'home') {
        return <span/>
      }

      if (headerType == 'profile') {
        component = <Typography classes={{root: classes.headerRoot}}
        variant="subheading" color="inherit">
          Profile
        </Typography>
      } else if (headerType == 'employees') {
        component = (<Breadcrumbs path={[{id: "company", name: company.name, type: "Company"},
                                         {id: "employees", name: "Employees", type: "Employee"}]}
                     company={company}
                     {...rest}/>
                    )
      } else if (headerType == 'createInvite') {
        component = (<Breadcrumbs path={[{id: "company", name: company.name, type: "Company"},
                                         {id: "invite", name: "Create Invite", type: "CreateInvite"}]}
                     company={company}
                     {...rest}/>)
      } else if (headerType == 'company') {
        component = (<Breadcrumbs path={[{id: "company", name: company.name, type: "Company"},]}
                     company={company}
                     {...rest}/>)
      } else if (headerType == 'createStrategyPage') {
        component = <Breadcrumbs
        path={[{id: "company", name: company.name, type: "Company"},
               {id: "strategy", name: "Create Strategy", type: "CreateStrategy"}]}
        company={company}
        {...rest}/>
      } else if (headerType == 'timeline') {
        component = <Breadcrumbs
        path={[{id: "company", name: company.name, type: "Company"},
               {id: this.props.params.strategyId, name: "Timeline", type: "Timeline"}]}
        company={company}
        {...rest}/>
      } else if (headerType == 'companyArchive') {
        component = <Breadcrumbs
        path={[{id: "company", name: company.name, type: "Company"},
               {id: "archive", name: "Archive", type: "Archive"}]}
        company={company}
        {...rest}/>
      } else if (headerType == 'adminCompanies') {
        component = (<Typography classes={{root: classes.headerRoot}}
         variant="subheading" color="inherit">
          Admin Companies
        </Typography>)
      } else if (headerType == 'createCompany') {
        component = (<Typography classes={{root: classes.headerRoot}}
                     variant="subheading" color="inherit">
                     Create Company
                     </Typography>)
      }else if (path) {
          component = <Breadcrumbs company={company} path={path} {...this.props}/>
      } else {
        if (company) {
          component = (<Typography classes={{root: classes.headerRoot}}
                     variant="subheading" color="inherit">
                       {company.name}
                     </Typography>)
        } else {
          component = <span/>
        }

      }

      const profileButton = (
        <IconButton
                 className={classes.profileButton}
                 aria-haspopup="true"
                 onClick={() => {
                   if (this.props.profile1.isSuperadmin) {
                     this.props.router.push("/admin/profile")
                   } else {
                     this.props.router.push("/profile")
                   }
                }}
                 color="inherit"
                 >
                <AccountCircle />
              </IconButton>
      )

      return (
        <AppBar classes={{root: classes.root}} position="static" color="default">
          <Toolbar variant="dense" classes={{gutters: classes.aardvarkFace}} className={classes.aardvarkFace}>
            <Hidden smDown>
              {component}
              {profileButton}
            </Hidden>
            <Hidden mdUp>
              <Button
                 color="transparent"
                 justIcon
                 aria-label="open drawer"
                 onClick={this.props.routes[0].helper.handleDrawerToggle}
                 >
                <Menu />
              </Button>
              {component}
              {profileButton}
            </Hidden>
          </Toolbar>
        </AppBar>
      )
    }
  }
)



export default Header
